import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';

import type { Id } from '../../api/models';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

type Variables = {
  debtorId: Id;
};

export async function subscribeToMonitoring(
  axiosInstance: Promise<AxiosInstance>,
  { debtorId }: Variables,
) {
  const instance = await axiosInstance;
  return instance.put(`debtors/${debtorId}/monitoring`);
}

export function useSubscribeToMonitoring() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, Variables>({
    mutationFn: variables => subscribeToMonitoring(axiosInstance, variables),
    onSuccess: (_response, { debtorId }) => {
      client.invalidateQueries({
        queryKey: ['monitoring', debtorId],
      });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, Variables, 'subscribeToMonitoring'>(
    'subscribeToMonitoring',
    mutation,
  );
}
